import { useSharedOauthApi } from '@/features/api/hooks/shared-oauth/useSharedOauthApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

/**
 * Note: we cannot call this mutation inside AuthProvider.tsx since useSharedOauthApi uses useAuth hook thus only children of the provider can call this otherwise we get a 401
 */
export const useRevokeAllRefreshTokens = () => {
  const api = useSharedOauthApi();

  return useApiMutation<void, unknown, void>({
    mutationFn: () => api.revokeAllRefreshTokens()
  });
};
